/**
 * Trainingszeit in der Zeitverteilung (F-34 E2, F-28) - rein und getestet.
 * Eingetragene Trainingstermine zaehlen schon ueber den Kalender (mit der
 * tatsaechlichen Zeit aus dem Protokoll). Was ohne Termin trainiert wurde -
 * freie Aktivitaeten, Nachtraege, nicht eingetragene Einheiten - kommt als
 * bestaetigter Block dazu: mit Beginn und Ende aus dem Protokoll, sonst ab
 * 18 Uhr mit der erfassten Dauer.
 */
import { protokollMinuten } from '@/domain/training/protokoll';
import type { TrainingsProtokoll } from '@/domain/training/typen';
import type { CalendarOccurrence, ID } from '@/domain/types';
import { atMinutes, toLocalDateTime } from '@/lib/datetime';

export function trainingsBloecke(protokolle: TrainingsProtokoll[], termine: CalendarOccurrence[], areaId: ID | null): CalendarOccurrence[] {
  const imKalender = new Set(termine.flatMap((o) => (o.training ? [`${o.training.planEinheitId}|${o.training.datum}`] : [])));
  return protokolle.flatMap((p) => {
    if (p.status !== 'fertig' || (p.planEinheitId && imKalender.has(`${p.planEinheitId}|${p.datum}`))) return [];
    let start = p.start ? toLocalDateTime(new Date(p.start)) : null;
    let end = p.ende ? toLocalDateTime(new Date(p.ende)) : null;
    if (!start || !end || end <= start) {
      const min = protokollMinuten(p);
      if (!min) return [];
      start = atMinutes(p.datum, 18 * 60);
      end = atMinutes(p.datum, Math.min(18 * 60 + min, 24 * 60 - 1));
    }
    return [{
      occurrenceId: `training:${p.id}`, eventId: `training:${p.id}`, isRecurring: false, isOverride: false,
      start, end, allDay: false, title: p.name, areaId,
      bestaetigung: { id: `training:${p.id}`, eventId: `training:${p.id}`, datum: p.datum, status: 'stattgefunden', updatedAt: p.updatedAt },
    }];
  });
}
